(function () {
    'use strict';

    run.admin.parts.tilesSuggestedVisibility = function() {
        // Groups visibility
        const view_suggested_toggler = document.getElementById('tools_view__suggested');
        if (view_suggested_toggler != null) {
            view_suggested_toggler.addEventListener('change', function(e) {
                // const target = document.getElementById('tool_group__suggested');
                const suggestions = document.querySelectorAll('.tool.is_suggested');
                const checked = this.checked;
                // window.localStorage.setItem('tools_view_suggested', checked);
                setCookie('tools_view_suggested', checked, 180);
                for (let i = 0; i < suggestions.length; i++) {
                    if (suggestions !== null) {
                        if (checked) {
                            suggestions[i].classList.add('visible');
                        } else {
                            suggestions[i].classList.remove('visible');
                        }
                    }
                }
            });
        }
    }
})();
